
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/shop",
      function () {
        return require("private-next-pages/[lang]/shop/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/shop"])
      });
    }
  